module.exports = __webpack_public_path__ + "static/media/ic_info.8b5646d2.svg";